import { Box, Button, Modal, Paper, Typography } from "@mui/material"

export const ConfirmFinalization = ({open, setOpen}) => {

  const handleConfirm = () => {
    setOpen(false)
  }

  return (
    <Modal open={open} onClose={()=>setOpen(false)} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4">Tilauksen vahvistus</Typography>
        <Typography variant="h5" sx={{ mt: 2 }}>Haluatko jatkaa?</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button onClick={()=>setOpen(false)}>Peruuta</Button>
          <Button variant="contained" color="primary" onClick={handleConfirm}>Vahvista</Button>
        </Box>
      </Paper>
    </Modal>
  )
}